import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function PastDueBanner() {
  const { user } = useAuth();
  const [opening, setOpening] = useState(false);

  if (!user || user.subscription_status !== 'past_due' || user.lifetime_free) {
    return null;
  }

  const openPortal = async () => {
    setOpening(true);
    try {
      const res = await api.post('/api/billing/portal');
      const url = res.data?.url || res.data?.portal_url;
      if (url) {
        window.location.href = url;
        return;
      }
      toast.error('Could not open billing. Contact support about billing.');
    } catch (err) {
      if (err?.response?.status === 409) {
        toast.error('Contact support about billing.');
      } else {
        toast.error("Couldn't open the billing portal. Try again or contact support.");
      }
    } finally {
      setOpening(false);
    }
  };

  return (
    <div className="bg-rose-600/90 text-white px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm">
      <AlertTriangle size={16} className="shrink-0" />
      <span>Payment failed — update your card to keep PropScope access.</span>
      <button
        type="button"
        onClick={openPortal}
        disabled={opening}
        className="underline font-semibold hover:text-rose-100 disabled:opacity-60"
      >
        {opening ? 'Opening…' : 'Update billing'}
      </button>
    </div>
  );
}
